export default "__VITE_ASSET__BjXhrI9g__"